import { app } from '../../app.module'
app
  // アカウントタグ管理モーダルを表示するためのボタン
  .directive('editAccountTagButton', () => {
    return {
      restrict: 'E',
      template: require('./edit-account-tag-button.pug')(),
      controller: function ($rootScope, $scope, $mdDialog, $attrs) {
        // タグボタンをクリックした際の処理
        $scope.showModal = function () {
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: {
            snsType: string
            accountId: number
          } = $rootScope.$new()

          // SNS種別
          modalScope.snsType = $attrs.snsType
          // アカウントID
          modalScope.accountId = $attrs.accountId

          // モーダルを表示する
          $mdDialog.show({
            template: require('./edit-account-tag-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
          })
        }
      },
    }
  })
